module.exports = __webpack_public_path__ + "img/Component.67350e36.png";